// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6514) return "static/chunks/6514-37eb3dd77be8834d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6793":"f57464ca23fa9330","9510":"667c8d3233180d56"}[chunkId] + ".js";
};